<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.0625 8L8 14.75L2.93652 8L8 1.24902L13.0625 8Z" stroke="currentColor" stroke-width="1.5"/>
<path d="M7.99082 1.44592V7.99997H3.24951L7.99082 1.44592Z" fill="currentColor"/>
<path d="M7.9999 14.6057L7.9999 7.99998L12.7412 7.99998L7.9999 14.6057Z" fill="currentColor"/>
</svg>
